import {
  appRoleLabel,
  formatApproverRoleList,
  pgApproverRoleLabel,
  type AppRole,
} from '@metycle/shared';

// Re-exported from the shared single source so the whole frontend humanises
// roles the same way (see @metycle/shared roles.ts).
export { appRoleLabel, formatApproverRoleList, pgApproverRoleLabel };

export const ROLE_LABEL: Record<AppRole, string> = {
  admin: 'Admin',
  trader: 'Trader',
  operations: 'Operations',
  hedging: 'Hedging Desk',
  cfo: 'CFO',
  management: 'Management',
  investor: 'Investor',
  risk_manager: 'Risk Manager',
  coo: 'COO',
};

const roleListFormatter = new Intl.ListFormat('en', { style: 'long', type: 'disjunction' });

export function formatRoleList(roles: readonly AppRole[]): string {
  return roleListFormatter.format(roles.map((role) => ROLE_LABEL[role]));
}

// Back-compat alias for the shared labeler (keeps existing call sites working).
export const approverRoleLabel = pgApproverRoleLabel;
